function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import ActionsCancelNormalXsmall from '@strava/icons/ActionsCancelNormalXsmall';
import Modal from '../Modal';
import Button from '../Button';
import { Tabs, TabList, Tab, TabPanel, TabPanels } from '../Tabs';
import styles from './styles.scss'; //
// ModalTabs
// --------------------

export function ModalTabs(_ref) {
  var className = _ref.className,
      children = _ref.children,
      otherProps = _objectWithoutProperties(_ref, ["className", "children"]);

  var classNames = [styles.tabs];

  if (className) {
    classNames.push(className);
  }

  return /*#__PURE__*/React.createElement(Tabs, Object.assign({
    className: classNames.join(' ')
  }, otherProps), children);
}
ModalTabs.defaultProps = {
  className: null
};
//
// ModalTabList
// --------------------
export function ModalTabList(_ref2) {
  var className = _ref2.className,
      children = _ref2.children;
  var classNames = [styles.tabList];

  if (className) {
    classNames.push(className);
  }

  return /*#__PURE__*/React.createElement(TabList, {
    className: classNames.join(' ')
  }, children);
}
ModalTabList.defaultProps = {
  className: null
};
//
// ModalTab
// --------------------
export function ModalTab(_ref3) {
  var className = _ref3.className,
      children = _ref3.children,
      disabled = _ref3.disabled;
  var classNames = [styles.tab];

  if (className) {
    classNames.push(className);
  }

  return /*#__PURE__*/React.createElement(Tab, {
    className: classNames.join(' '),
    disabled: disabled
  }, children);
}
ModalTab.defaultProps = {
  className: null,
  disabled: false
};
//
// ModalTabPanels
// --------------------
export function ModalTabPanels(_ref4) {
  var className = _ref4.className,
      children = _ref4.children;
  var classNames = [styles.tabPanels];

  if (className) {
    classNames.push(className);
  }

  return /*#__PURE__*/React.createElement(TabPanels, {
    className: classNames.join(' ')
  }, children);
}
ModalTabPanels.defaultProps = {
  className: null
};
//
// ModalTabPanels
// --------------------
export function ModalTabPanel(_ref5) {
  var className = _ref5.className,
      children = _ref5.children;
  var classNames = [styles.tabPanel];

  if (className) {
    classNames.push(className);
  }

  return /*#__PURE__*/React.createElement(TabPanel, {
    className: classNames.join(' ')
  }, children);
}
ModalTabPanel.defaultProps = {
  className: null
};
//
// ModalWithTabs
// --------------------
export default function ModalWithTabs(_ref6) {
  var isOpen = _ref6.isOpen,
      className = _ref6.className,
      onDismiss = _ref6.onDismiss,
      children = _ref6.children,
      title = _ref6.title,
      logo = _ref6.logo;
  var classNames = [styles.dialog];

  if (className) {
    classNames.push(className);
  }

  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: isOpen,
    className: classNames.join(' '),
    onDismiss: onDismiss
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.header
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.headerContent
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-title3 text-book mt-0 mb-0 ".concat(styles.headerTitle)
  }, logo && /*#__PURE__*/React.createElement("img", {
    src: logo,
    alt: title,
    className: styles.logo
  }), title)), /*#__PURE__*/React.createElement(Button, {
    variant: "icon",
    className: styles.closeButton,
    onClick: onDismiss,
    tabIndex: -1
  }, /*#__PURE__*/React.createElement(ActionsCancelNormalXsmall, null))), children));
}
ModalWithTabs.defaultProps = {
  isOpen: false,
  className: null,
  onDismiss: function onDismiss() {},
  logo: null
};